module.exports = __webpack_public_path__ + "0e6b93c24255f4faca98667917637241.mp4";